import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ReportingScopeService } from '../services/reporting-scope.service';

/**
 * Data-residency Phase 4: guards the corporate reporting route. Allows only users
 * for whom corporate (cross-region, PII-redacted) reporting is in scope — HQ cell,
 * residency enabled, Admin/SuperAdmin — mirroring the backend AdminOrSuperAdmin
 * policy on the corporate endpoints. While residency is disabled (today's default)
 * this always redirects away, so the route is unreachable.
 */
@Injectable({ providedIn: 'root' })
export class CorporateReportingGuard implements CanActivate {
    constructor(
        private reportingScopeService: ReportingScopeService,
        private authService: AuthService,
        private router: Router,
    ) {}

    canActivate(): boolean {
        if (this.reportingScopeService.canAccessCorporateReporting) {
            return true;
        }
        this.router.navigate([this.authService.getLandingPageUrl()]);
        return false;
    }
}
